import { WSQueryConfig } from "@ws-react-query";
import {
  listRequirementDefinitions,
  RequirementDefinitionFilter
} from "../../../services/requirementDefinitions/listRequirementDefinitions";
import { ListRequestQuery, WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { QUERY_REQUIREMENT_DEFINITIONS_LIST_SIZE } from "../keys";

export const useQueryRequirementDefinitionListSize = (
  params: ListRequestQuery<
    RequirementDefinitionFilter,
    {
      createdAt?: "asc" | "desc";
    }
  >,

  config?: WSQueryConfig<number, WSServiceError>
) => {
  const { sort, filter } = params || {};

  return useWSQuery<number, WSServiceError>(
    [QUERY_REQUIREMENT_DEFINITIONS_LIST_SIZE, params],
    async () => {
      const { summary } = await listRequirementDefinitions({
        filter,
        page: { size: 1, number: 1 },
        sort
      });

      return summary.listSize;
    },
    {
      refetchOnMount: false,
      retry: false,
      ...config
    }
  );
};
